function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime/helpers/nonIterableSpread.js
 ** module id = 621
 ** module chunks = 0
 **/